<template>
  <div class="background">
    <div class="header" v-if="currentPage && currentPage.title === 'Filter + Blocker'">
      <h2 class="bold">Filter + </h2>
      <h2>Blocker</h2>
    </div>
    <div class="header" v-else-if="currentPage && currentPage.title">
      <button class="backButton" @click="goBack" v-if="showBack">
        <font-awesome-icon :icon="['fas', 'arrow-left']" />
      </button>
      <h2 class="bold">{{currentPage.title.split(' ')[0]}}</h2>
      <h2>{{currentPage.title.split(' ')[1]}}</h2>
    </div>
    <div class="content">
      <router-view/>
    </div>
    <div v-if="showFooter" class="footer">
      <font-awesome-icon @click="toggleMenu" class="icon" :icon="['fas', 'bars']" />
      <div class="footerVerticalLine"></div>
      <font-awesome-icon @click="goToPage(dashboardPage)" class="icon" :icon="['fas', 'house']" />
      <div class="guardianButtonWrapper">
        <button @click="toggleChat" class="guardianButton">
          <img class="KovoLogoWhite" src="/static/img/KovoLogoWhite.svg" alt="KovoLogoWhite">
        </button>
      </div>
      <div style="position: relative">
        <font-awesome-icon class="icon" :icon="['fas', 'bell']" @click="toggleNotification" />
        <div v-if="unreadCount" class="unreadCount">
          {{unreadCount}}
        </div>
      </div>
      <div class="footerVerticalLine"></div>
      <font-awesome-icon @click="goToPage(settingsPage)" class="icon" :icon="['fas', 'gear']"/>
    </div>
    <transition name="fade">
      <div v-if="menuOpen" class="overlay" @click.self="closeMenu"></div>
    </transition>
    <transition name="slide">
      <div v-if="menuOpen" class="hamburgerMenu">
        <div class="menuHeader">
          <img class="menuHeaderLogo" src="/static/img/KovoLogoWhite.svg" alt="">
        </div>
        <!-- your menu content here -->
        <div class="pageDiv" v-for="page of pages" v-bind:key="page.name" @click="handlePageClick(page)" :class="{ 'page-restricted': !canAccessPage(page.name) }">
          <vue-feather :color="textPrimary" :stroke="textPrimary" :type="page.icon"/>
          <div class="width75">
            <h4>{{page.label}}</h4>
            <span v-if="!canAccessPage(page.name)" class="restriction-badge">{{ getRestrictionBadge(page.name) }}</span>
          </div>
          <vue-feather v-if="canAccessPage(page.name)" :color="textPrimary" :stroke="textPrimary" type="chevron-right"/>
          <font-awesome-icon v-else :icon="['fas', 'lock']" class="lock-icon"/>
        </div>
      </div>
    </transition>
    <ChatPage
        :open="chatPage.open"
        @close="toggleChat"
    />
    <NotificationPage
        :open="notificationPage.open"
        @close="toggleNotification"
    />
    <UpgradePromptPage
        :open="upgradePage.open"
        :feature="upgradePage.feature"
        :return-path="upgradePage.returnPath"
        @close="toggleUpgrade"
        @close-menu="closeMenu"
    />
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
  </div>
</template>

<script>
import PullToRefresh from 'pulltorefreshjs';
import {useLoginStore} from "@/stores/loginStore";
import {useNotificationStore} from "@/stores/notificationStore";
import {useThemeStore} from "@/stores/themeStore";
import ChatPage from "@/pages/ChatPage.vue";
import MessageModal from "@/components/MessageModal.vue";
import NotificationPage from "@/pages/NotificationPage.vue";
import UpgradePromptPage from "@/pages/UpgradePromptPage.vue";
import DeviceAPIService from "@/servicehandlers/DeviceAPIService";
import SubscriptionPermissionService from "@/services/SubscriptionPermissionService";
const deviceAPIService = new DeviceAPIService()

export default {
  name: 'DashboardPage',
  components: {
    NotificationPage,
    MessageModal,
    ChatPage,
    UpgradePromptPage,
  },
  data(){
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
      pages: [
        {
          name: 'dashboard',
          title: 'User Dashboard',
          label: 'Dashboard',
          icon: 'home',
        },
        {
          name: 'speedtest',
          title: 'Speed Test',
          label: 'Speed Test',
          icon: 'zap',
        },
        {
          name: 'filterBlocker',
          title: 'Filter + Blocker',
          label: 'Filter + Blocker',
          icon: 'slash',
        },
        {
          name: 'devicesManager',
          title: 'Devices Manager',
          label: 'Devices Manager',
          icon: 'smartphone',
        },
        /*{
          name: 'firewallRules',
          title: 'Firewall Rules',
          label: 'Firewall Rules',
          icon: 'shield',
        },*/
        {
          name: 'network',
          title: 'Network',
          label: 'Network',
          icon: 'globe',
        },
        {
          name: 'networkStats',
          title: 'Network Stats',
          label: 'Network Stats',
          icon: 'pie-chart',
        },
        {
          name: 'portForwarding',
          title: 'Port Forwarding',
          label: 'Port Forwarding',
          icon: 'fast-forward',
        },
        {
          name: 'siteManager',
          title: 'Site Manager',
          label: 'Site Manager',
          icon: 'clipboard',
        },
        {
          name: 'vpn',
          title: 'VPN Connection',
          label: 'VPN Connection',
          icon: 'shield',
        },
        {
          name: 'techSupport',
          title: 'Tech Support',
          label: 'Tech Support',
          icon: 'phone',
        },
        {
          name: 'settings',
          title: 'Settings',
          label: 'Settings',
          icon: 'settings',
        },
      ],
      currentUser: useLoginStore().getUser,
      showFooter: true,
      currentPage: null,
      menuOpen: false,
      themeStore: useThemeStore(),
      settingsPage: {
        name: 'settings',
        title: 'Settings',
        label: 'Settings',
      },
      chatPage: {
        name: 'chat',
        title: 'Chat',
        label: 'Chat',
        open: false,
      },
      notificationPage: {
        name: 'notification',
        title: 'Notifications',
        label: 'Notifications',
        open: false,
      },
      upgradePage: {
        name: 'upgrade',
        title: 'Upgrade',
        label: 'Upgrade',
        open: false,
        feature: '',
        returnPath: '/',
      },
      dashboardPage: {
        name: 'dashboard',
        title: 'User Dashboard',
        label: 'Dashboard',
      },
      notificationStore: useNotificationStore(),
      devicePollingInterval: null,
      deviceCheckRetries: 0,
      maxRetries: 3,
    }
  },
  computed: {
    unreadCount(){
      return this.notificationStore.formattedUnreadCount;
    },
    showBack(){
      if (this.$route.name === 'billingSubscription') return true
      return false
    },
    textPrimary(){
      // Make textPrimary reactive to theme changes
      const colors = this.themeStore.getCurrentColors;
      return colors['--text-primary'];
    },
    subscriptionType(){
      return useLoginStore().getSubscriptionType;
    },
    deviceOnline(){
      return useLoginStore().getDeviceOnline;
    },
  },
  watch: {
    '$route.name'() {
      this.updateCurrentPage()
      this.pingDevice()
    }
  },
  mounted(){
    //console.clear()
    this.pingDevice()
    this.updateCurrentPage()
    this.checkForBlockedRouteQuery()

    this.initPullToRefresh();
    this.startBackgroundPolling();
  },
  beforeDestroy() {
    if (this.ptrInstance) {
      this.ptrInstance.destroy();
    }
    if (this.devicePollingInterval) {
      clearInterval(this.devicePollingInterval);
    }
  },
  methods: {
    async pingDevice(){
      // Only ping device for users with device subscription
      if (this.subscriptionType !== 'device') {
        useLoginStore().setDeviceOnline(false)
        return
      }
      
      try {
        let ping = await deviceAPIService.getSerialNumber(this.$router, useLoginStore())
        if (ping.machineId){
          useLoginStore().setDeviceOnline(true)
          this.deviceCheckRetries = 0
        } else {
          useLoginStore().setDeviceOnline(false)
        }
      } catch (e) {
        useLoginStore().setDeviceOnline(false)
        this.deviceCheckRetries++
      }
    },
    startBackgroundPolling() {
      this.devicePollingInterval = setInterval(() => {
        this.pingDevice()
      }, this.getPollingInterval())
    },
    getPollingInterval() {
      const baseInterval = 30000
      const retryMultiplier = Math.min(this.deviceCheckRetries, this.maxRetries)
      return baseInterval + (retryMultiplier * 15000)
    },
    initPullToRefresh() {
      try {
        console.log('Pull init')
        this.ptrInstance = PullToRefresh.init({
          distThreshold: 100,
          distMax: 120,
          distReload: 80,
          onRefresh() {
            window.location.reload();
          },
          shouldPullToRefresh() {
            const loading = document.getElementById('loadingPage')
            const content = document.querySelector('.content');
            return content.scrollTop === 0 && !loading;
          }
        });
      } catch (e) {
        console.log(e)
      }
    },
    useLoginStore,
    updateCurrentPage(){
      if (this.pages.some(page => page.name === this.$route.name)){
        this.currentPage = this.pages.find(page => page.name === this.$route.name)
      } else if (this.$route.name === 'profile'){
        this.currentPage = this.profilePage
      } else if (this.$route.name === 'billingSubscription'){
        this.currentPage = {
          name: 'billingSubscription',
          title: 'Billing',
          label: 'Billing',
        }
      } else {
        this.goToPage(this.pages[0])
      }
    },
    goToPage(page){
      if (this.$route.name !== page.name) {
        this.$router.push({
          name: page.name
        })
        this.currentPage = page
      }
      this.closeMenu()
    },
    goBack(){
      this.$router.go(-1)
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
    toggleChat() {
      this.chatPage.open = !this.chatPage.open;
      if (this.chatPage.open){
        this.currentPage = this.chatPage
      } else {
        this.updateCurrentPage()
      }
    },
    toggleNotification() {
      this.notificationPage.open = !this.notificationPage.open;
      if (this.notificationPage.open){
        this.currentPage = this.notificationPage
      } else {
        this.updateCurrentPage()
      }
    },
    toggleUpgrade() {
      this.upgradePage.open = !this.upgradePage.open;
      if (this.upgradePage.open){
        this.currentPage = this.upgradePage
      } else {
        this.updateCurrentPage()
      }
    },
    addTestNotification() {
      this.notificationStore.addMockNotification({
        title: 'Test Notification',
        body: 'This is a test notification from the app',
        type: 'System'
      });
    },
    canAccessPage(pageName) {
      return SubscriptionPermissionService.canAccessRoute(
        this.subscriptionType,
        pageName,
        this.deviceOnline
      );
    },
    getRestrictionBadge(pageName) {
      const accessLevel = SubscriptionPermissionService.getAccessLevel(
        this.subscriptionType,
        SubscriptionPermissionService.ROUTE_FEATURE_MAP[pageName],
        this.deviceOnline
      );
      
      switch (accessLevel) {
        case 'blocked':
          return this.subscriptionType === 'free' ? 'Upgrade Required' : 'Restricted';
        case 'upgrade_required':
          return 'Device Plan Required';
        case 'device_offline':
          return 'Device Offline';
        default:
          return '';
      }
    },
    handlePageClick(page) {
      if (this.canAccessPage(page.name)) {
        this.goToPage(page);
      } else {
        this.showUpgradeModal(page.name);
      }
    },
    showUpgradeModal(pageName) {
      const featureName = SubscriptionPermissionService.ROUTE_FEATURE_MAP[pageName];
      this.upgradePage.feature = featureName;
      this.upgradePage.returnPath = this.$route.path;
      this.upgradePage.open = true;
      this.currentPage = this.upgradePage;
    },
    checkForBlockedRouteQuery() {
      if (this.$route.query.blocked && this.$route.query.reason) {
        if (this.$route.query.blocked === 'device') {
          // Show device-related modal
          const routeName = this.$route.name;
          const featureName = SubscriptionPermissionService.ROUTE_FEATURE_MAP[routeName];
          if (featureName) {
            this.showUpgradeModal(routeName);
          }
        } else {
          // Show upgrade modal for the blocked route
          this.showUpgradeModal(this.$route.query.blocked);
        }
        
        // Clean up the query parameters
        this.$router.replace({ name: this.$route.name });
      }
    }
  },
}
</script>

<style scoped>
.unreadCount{
  background: linear-gradient(180deg, #E54444 0%, #CE2626 100%);
  border: 1px solid #AE2401;
  color: var(--text-primary);
  font-size: 10px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: -7.5px;
  top: -7.5px;
}
.pageDiv h4{
  text-align: left;
}
h4{
  text-align: left;
}
.menuHeaderLogo {
  position: absolute;
  left: 30px;
  top: 50%;
  width: 60px;
  z-index: 1;
  transform: translate(0, -50%);
}
.menuHeader h1{
  position: relative;
  z-index: 10;
  height: 100%;
  text-align: right;
  padding: 15px;
}
.pagesIcon{
  color: var(--text-primary) !important;
  width: 24px;
}
.icon{
  color: var(--text-primary);
  font-size: 20px;
  width: 24px;
}
.content{
  position: relative;
  height: calc(100vh - var(--header-height));
  width: calc(100vw);
  padding: 15px;
  padding-bottom: calc(var(--footer-height) + 25px);
  overflow-x: auto;
  margin: 0;
  background: transparent;
  z-index: 1;
}
.background{
  background: var(--background-gradient);
  margin: 0;
}
.guardianButton{
  margin-top: -40px;
}
.profileImage{
  width: 24px;
  height: 24px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border: 1px solid white;
}

/* slide-in/out animation */
.slide-enter-active,
.slide-leave-active {
  transition: transform .3s ease;
}
.slide-enter {
  transform: translateX(-100%); /* start off-screen to the left */
}
.slide-enter-to {
  transform: translateX(0);     /* slide into place */
}
.slide-leave {
  transform: translateX(0);
}
.slide-leave-to {
  transform: translateX(-100%);
}

/* fade-in/out animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter {
  opacity: 0;
  pointer-events: none;
}
.fade-enter-to {
  opacity: 1;
  pointer-events: auto;
}
.fade-leave {
  opacity: 1;
  pointer-events: auto;
}
.fade-leave-to {
  opacity: 0;
  pointer-events: none;
}

/* Subscription-related styles */
.page-restricted {
  opacity: 0.6;
  background: rgba(116, 116, 116, 0.1);
}

.page-restricted h4 {
  color: var(--text-secondary) !important;
}

.restriction-badge {
  font-size: 11px;
  color: var(--color-secondary-button);
  background: rgba(243, 156, 18, 0.2);
  padding: 2px 6px;
  border-radius: 10px;
  margin-top: 2px;
  display: block;
  font-weight: bold;
}

.lock-icon {
  color: var(--text-secondary);
  font-size: 16px;
}
</style>
